export const TITLE = "Piaggio E-Xtra FX Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Piaggio E-Xtra FX Electric price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Piaggio E-Xtra FX Electric, Piaggio E-Xtra FX, Piaggio electric vehicle, Piaggio electric cargo vehicle, Piaggio electric commercial vehicle, Piaggio E-Xtra FX price, Piaggio E-Xtra FX specifications, Piaggio E-Xtra FX range, Piaggio E-Xtra FX load capacity, Piaggio electric vehicle price, Piaggio commercial vehicle, Piaggio electric auto, Piaggio EV, Piaggio electric truck, Piaggio cargo vehicle, Piaggio electric vehicle specifications, Piaggio electric vehicle features, Piaggio electric vehicle reviews, Piaggio electric vehicle dealer, Piaggio Ape E-Xtra FX, Piaggio electric three wheeler",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Piaggio E-Xtra FX Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Piaggio E-Xtra FX Electric price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Piaggio E-Xtra FX Electric price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Piaggio E-Xtra FX Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const HIGHLIGHTS_DESCRIPTION = "The Piaggio Ape E-Xtra Fx Electric Auto is your best option for carrying goods because it comes with a high payload capacity of 550 kgs and 8 kW power. It is a clutch-free and gearless drive, giving you the ultimate comfort and high savings on fuel. This electric three-wheeler has a lithium-ion battery that'll last you a long time and an app to track the EV in real-time. Get all of this for just ₹12,961* per month.";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING = "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Piaggio E-Xtra FX";

export const BRAND_DEALER_HEADING = "Piaggio E-Xtra FX Electric Truck Dealers Near Me:";

export const BRAND_DEALER_DESCRIPITION = "As Piaggio's influence continues to extend across India, its presence is becoming increasingly noticeable. With a rising number of individuals choosing Piaggio's top-notch mobility solutions, known for delivering excellent value for the price, Turno proudly presents the outstanding Piaggio E-Xtra FX electric commercial vehicle, at an unbelievably budget-friendly price.";

export const FAQ_HEADING_TEXT = "FAQs on Piaggio E-Xtra FX";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Piaggio", href: "/electric-commercial-vehicles/Piaggio" },
  { label: "E-Xtra FX" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Piaggio",
      item: "https://www.turno.club/electric-commercial-vehicles/Piaggio",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "E-Xtra FX",
      item: VEHICLE_LINK,
    },
  ],
};
